export const ENTRANCE_DOORS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/vhodnye-dveri-na-zakaz/';

export const ENTRANCE_DOORS_ELEMENT_BLOCK = 'landingVhodnyeDveri';

export const ENTRANCE_DOORS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto/fudzi/elbrus/images/landings/entrance-doors-mf';

export const ENTRANCE_DOORS_LANDING_NAME = 'entrance-doors';

export const ENTRANCE_DOORS_CDN_LANDING_NAME = 'entrance-doors-mf';

export const ENTRANCE_DOORS_SERVICE_ID = '1763';
